module.exports = __webpack_public_path__ + "static/media/instructivor2.4864fa67.png";